import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Wanna a gantt chart editor for free? Download for `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/jQueryGantt/releases/download/HEAD/jQueryGantt-1.0.0.dmg"
      }}>{`Mac`}</a>{` or `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/jQueryGantt/releases/download/HEAD/jQueryGantt-1.0.0.x86_64.zip"
      }}>{`Centos`}</a>{`.`}</p>
    <h1>{`Findings`}</h1>
    <p>{`I assume you know what's `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Gantt_chart"
      }}>{`Gantt`}</a>{` chart. `}<a parentName="p" {...{
        "href": "https://github.com/robicch/jQueryGantt"
      }}>{`jQueryGantt`}</a>{` is an ancient pure front web app of Gantt chart that looks nice. It's also free, simple and quite easy to use. It'll be even nicer if it's native app. At first, I thought I could make a native app out of this pure frontend web app using `}<a parentName="p" {...{
        "href": "https://github.com/jiahaog/nativefier"
      }}>{`nativefier`}</a>{`. However, it seems not to work as I expected. It still connects to localhost server and cannot save frontend layout page which, in my understanding, is not `}<em parentName="p">{`nativefied`}</em>{`. Plus, save/load is not functional. Ok, there's no magic for native and free app: we need to manually wrap it up into a fresh handmade `}<a parentName="p" {...{
        "href": "https://electronjs.org/"
      }}>{`Electron`}</a>{` app with patience. Luckily Electron provides very smooth browser to desktop app (chrome based) migration. After moving `}<a parentName="p" {...{
        "href": "https://jquery.com/"
      }}>{`jquery`}</a>{` etc. modules in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`package.json`}</code>{`, everything almost works out of box. Nice!`}</p>
    <h1>{`Keep Fixing`}</h1>
    <p>{`Even though not much migration work, some parts of the software doesn't work as advertised (buggy) e.g. adding new entry, endless recursion etc.. But since I have source code, I can just fix+use it and later distribute it using `}<a parentName="p" {...{
        "href": "https://www.electron.build/"
      }}>{`electron.build`}</a>{`. This distribution tool allow you to download and use for `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/jQueryGantt/releases"
      }}>{`free`}</a>{` 🙌!
For developers, just directly clone `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/jQueryGantt"
      }}>{`this`}</a>{` repo and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm start`}</code>{` your god mod.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      